import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import api from "../../utils/Api";
import history from "../../utils/history";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../redux/index";
import * as Yup from "yup";
import Header from "../../containers/Header";
import style from "./ResetPassword.module.css";
import ttmLoader from "../../assets/images/ttm-loader.gif";

export class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <Header />

        <div className={style.loginMainWrapper}>
          <div className="container h-100">
            <div className={`row ${style.alignCenter}`}>
              <div className="col-md-12">
                <Formik
                  initialValues={{
                    email: "",
                  }}
                  //Validation schema
                  validationSchema={Yup.object().shape({
                    email: Yup.string()
                      .email("Email is invalid")
                      .required("Email is required"),
                  })}
                  //Post data to API
                  onSubmit={async (data) => {
                    this.setState({
                      isLoading: true,
                      errorMessage: "",

                    });
                    // Paylaod
                    const payload = {
                      email: data.email,
                    };
                    console.log("Reset password payload", payload);

                    try {
                      const response = await api.post(
                        "user/resetpassword",
                        payload
                      );
                      if (response.status === 200) {
                        this.setState({
                          isLoading: false,
                          successMessage:
                            "Password sent successfully. Please check your email",
                        });
                      }
                      setTimeout(() => {
                        this.setState({
                          successMessage: "",
                        });
                        localStorage.clear("USER_INFO");
                        history.push("/");
                      }, 3000);
                    } catch (error) {
                      if (error.response) {
                        this.setState({
                          isLoading: false,
                          errorMessage: error.response.data.message,
                        });
                        // setTimeout(() => {
                        //   this.setState({
                        //     errorMessage: "",
                        //   });
                        // }, 2000);
                      }
                    }
                  }}
                  render={({ isSubmitting, errors, status, touched }) => (
                    <Form>
                      <h2 className="ff-montserrat-sb text-center">
                        Reset Password
                      </h2>
                      <p className="text-center">
                        Enter your User Email Id. Your new password will be sent
                        to this email address.
                      </p>
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <Field
                          name="email"
                          type="text"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.email && touched.email ? " is-invalid" : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          {this.state.isLoading ? (
                            <div className={style.loadingWrapper}>
                              <img src={ttmLoader} className={style.loading} />
                            </div>
                          ) : (
                            <div>
                              {this.state.successMessage && (
                                <p className={style.successMessage}>
                                  {this.state.successMessage}
                                </p>
                              )}
                              {this.state.errorMessage && (
                                <p className={style.errorMessage}>
                                  {this.state.errorMessage}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="form-group mt-4">
                        <button
                          type="submit"
                          className={`btn btn-block techtomed-btn-primary ${style["techtomed-btn-primary"]}`}
                        >
                          Reset Password
                        </button>
                      </div>
                    </Form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ResetPassword;
